import { TRACKING_UUID_KEY } from 'config'
import { addUtmTracking } from 'services'

export const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_id',
  'utm_term',
  'utm_content',
  'campaignid',
  'adgroupid',
  'keyword',
  'device',
  'adid',
] as const

export type UtmParam = typeof UTM_PARAMS[number]

export const extractUtmParams = (urlOrSearchParams: string | URLSearchParams): Record<string, string> => {
  const params = typeof urlOrSearchParams === 'string' ? new URLSearchParams(urlOrSearchParams) : urlOrSearchParams

  const utmData: Record<string, string> = {}

  UTM_PARAMS.forEach((param) => {
    const value = params.get(param)
    if (value) {
      utmData[param] = value
    }
  })

  return utmData
}

export const trackApplicationStart = async () => {
  const storedUuid = sessionStorage.getItem(TRACKING_UUID_KEY)
  if (storedUuid) return

  try {
    const utmParams = extractUtmParams(window.location.search)
    if (!Object.keys(utmParams).length) return

    const currentUrl = typeof window !== 'undefined' ? window.location.href : ''

    const data = await addUtmTracking('intro', {
      ...utmParams,
      url: currentUrl,
    })

    // Store the UUID from the response
    if (data?.uuid) {
      const uuid = data.uuid
      if (typeof window !== 'undefined') {
        sessionStorage.setItem(TRACKING_UUID_KEY, uuid)
      }
    }
  } catch (error) {
    console.error('Failed to track application start:', error)
  }
}
